import clsx from "clsx"
import { toAbsoluteUrl } from "../../../../helpers"

export const MsalSignInButton = ({ loading, className, onClick }: {
    loading?: boolean,
    className?: string,
    onClick: () => void
}) => {
    return <>
        <style>
            {`
                @keyframes blink {
                    0% { opacity: 1; }
                    50% { opacity: 0.5; }
                    100% { opacity: 1; }
                }

                .blinking {
                    animation: blink 1s infinite;
                }

                .blinking:hover {
                    animation: none;
                }
            `}
        </style>
        <button
            type='button'
            disabled={loading}
            className={clsx(className, 'btn btn-primary btn-lg w-100', 'blinking')}
            onClick={() => onClick()}
        >
            {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
            )}
            {!loading && <>
                <div className="d-flex flex-row align-items-center">
                    <img
                        alt='Logo'
                        src={toAbsoluteUrl('/media/svg/brand-logos/microsoft-5.svg')}
                        className='h-20px me-3'
                    />
                    <div className="flex-fill d-flex flex-column justify-content-center align-items-center">
                        <p className="m-0 fs-6">Sign in with your</p>
                        <p className="m-0 fs-8">Scholar E-Mail ID</p>
                    </div>
                </div>
            </>
            }
        </button>
    </>
}